export enum InvitationType {
  Unknown,
  Portal,
  Company,
  Location,
  User,
  ConfigurePassword
}
